var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCheckmark = function SvgCheckmark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 11.1634 11.1634 4 20 4V4C28.8366 4 36 11.1634 36 20V20C36 28.8366 28.8366 36 20 36V36C11.1634 36 4 28.8366 4 20V20Z",
    fill: "#00DDA9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.1996L12.8 19.9996L11.4 21.3996L17 26.9996L29 14.9996L27.6 13.5996L17 24.1996Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 32C13.3726 32 8 26.6274 8 20H0C0 31.0457 8.95431 40 20 40V32ZM32 20C32 26.6274 26.6274 32 20 32V40C31.0457 40 40 31.0457 40 20H32ZM20 8C26.6274 8 32 13.3726 32 20H40C40 8.95431 31.0457 0 20 0V8ZM20 0C8.95431 0 0 8.95431 0 20H8C8 13.3726 13.3726 8 20 8V0Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckmark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkmark.eb32ab8b.svg";
export { ForwardRef as ReactComponent };